import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    campaignName: string,
    onDelete: () => void,
    onCancel: () => void
}

const DeleteCampaign: React.FunctionComponent<IProps> = (props) => {
    return (
        <Modal bsSize='xs' backdrop='static' show={props.show} onHide={props.onDelete}  >
            <Modal.Header closeButton>
                <Modal.Title>Delete Campaign</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    Are you sure you would like to delete campaign: <strong>{props.campaignName}</strong>?
                </div>
            </Modal.Body>
            <Modal.Footer >
                <Button bsStyle='danger' onClick={props.onDelete}>Delete Campaign</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteCampaign;